var file_upload_viewer_default = {
  "fontElementMap": "j67tO",
  "file_upload_container": "pJDda",
  "file_upload_link": "I4DPT",
  "file_upload_error_container": "gZ8xD",
  "file_upload_file_info": "bIvOn",
  "file_upload_type_icon": "_8VEJt",
  "file_upload_status_icon_container": "x8WKE",
  "file_upload_status_icon": "_9Bvqk",
  "file_upload_description": "xueGq",
  "file_upload_name_container": "SpYAu",
  "file_upload_name": "_16aZ-",
  "file_upload_extension": "Ulia5",
  "file_loader_icon": "GUyN7",
  "file_upload_icon_frame": "AmKep",
  "file_upload_icon_background": "iuMY4"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
